import { useEffect } from 'react';
import { useParams } from 'react-router';
import PersonaEntregaForm from '../../components/personal-entrega/PersonaEntregaForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalEntregaStore,
  type ActualizarPersonaEntrega
} from '../../stores/personal-entrega/personal-entrega.store';

const EditarPersonaEntrega = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: persona,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = usePersonalEntregaStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
    cargarCiudades();
    cargarEstados();
  }, [id]);

  const handleSave = (values: ActualizarPersonaEntrega) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <PersonaEntregaForm
      persona={persona}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default EditarPersonaEntrega;
